import { ApiError } from "./http";

/** User-safe messages for login transport failures (no account enumeration). */
export function loginTransportErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401 || error.status === 400) {
      return error.message || "Unable to sign in. Check your details and try again.";
    }
    if (error.status === 429) {
      return "Too many attempts. Please wait a moment and try again.";
    }
    if (error.status === 404) {
      return "Unable to reach FSWL right now. Please try again.";
    }
    if (error.status >= 500) {
      return "FSWL is temporarily unavailable. Please try again shortly.";
    }
    return "Something went wrong. Please try again.";
  }

  if (error instanceof TypeError) {
    return "Unable to reach FSWL right now. Please try again.";
  }

  return "Unable to reach FSWL right now. Please try again.";
}
